export default __webpack_public_path__ + "static/107980-74366721bcbc76d416e656bb2e9a52cf.jpg";